jQuery(document).ready(function ($) {
  // Swiper and Owl are only loaded on pages whose markup uses them (include_js);
  // fall back to no-ops so the rest of this file still runs everywhere.
  var Swiper = window.Swiper || function () {};
  if (!$.fn.owlCarousel) { $.fn.owlCarousel = function () { return this; }; }
  // $('#watchMoreButton').on('click', function(){
  //     console.log('jkdhak')
  // });

  $(".tab-title .title").on("click", function () {
    // Hide all tab contents
    $(".tab-content").hide();
    $(this).addClass("active");
    $(this).siblings().removeClass("active");

    // Show the clicked tab's content
    const tabId = $(this).data("tab");
    $("#" + tabId).show();
    $("#" + tabId)
      .find(".content-left .item")
      .first()
      .addClass("active");
    $("#" + tabId)
      .find(".content-right .item")
      .first()
      .addClass("active");
  });

  $(".tab-content .content .content-right .item .content-title").hover(
    function () {
      // Get the data-tab of the hovered element
      var targetTab = $(this).parent(".item").data("tab");
      $(this).parent(".item").addClass("active");
      $(this).parent(".item").siblings().removeClass("active");

      // Remove 'active' class from all items in content-left
      $(".content-left .item").removeClass("active");

      // Add 'active' class to the corresponding item in content-left
      $("#" + targetTab).addClass("active");
    }
  );

  // Initialize first tab
  $(".tab-content").hide(); // Hide all tab contents initially
  $(".tab-content").first().show();
  $(".tab-title .title").first().addClass("active");
  $(".tab-content .content .content-left .item").first().addClass("active");
  $(".tab-content .content .content-right .item").first().addClass("active");

  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".mySwiper .swiper-pagination",
      clickable: true,
    },
  });

  var swiper = new Swiper(".swiper-slider.swiper", {
    slidesPerView: 1,
    spaceBetween: 16,
    centeredSlides: true,
    roundLengths: true,
    loop: true,
    loopAdditionalSlides: 16,
  });

  var swiper = new Swiper(".item-list", {
    slidesPerView: 5,
    spaceBetween: 25,
    breakpoints: {
      575: {
        slidesPerView: 1.28,
      },
      767: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
      1440: {
        slidesPerView: 5,
      },
    },
  });

  $('.image-slide-owl').owlCarousel({
    loop: true,
    center: true,
    margin: -80,
    nav: true,
    navText: [
      '<div class="owl-prev"></div>',
      '<div class="owl-next"></div>',
    ],
    dots: false,
    responsive: {
      0: {
        items: 3,
        margin: -80,
      },
      576: {
        items: 3,
        margin: -80,
      },
      768: {
        items: 5,
        margin: -50,
      },
      992: {
        items: 5,
        margin: -100,
      },
      1025: {
        items: 5,
        margin: -120,
      },
      1200: {
        items: 7,
        margin: -160,
      },
    },
  });

  let maxHeight = 0;

  // Find highest element
  $(".tt-col-description").each(function () {
    let height = $(this).outerHeight();
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  // Set height of all elements to highest element
  $(".tt-col-description").height(maxHeight);

  let maxIconHeight = 0;
  // Find highest element
  $(".tt-col-icon").each(function () {
    let height = $(this).outerHeight();
    if (height > maxIconHeight) {
      maxIconHeight = height;
    }
  });

  // Set height of all elements to highest element
  $(".tt-col-icon").height(maxIconHeight);
  
  function updateImageWidth() {
    const bannerSection = $('.banner-top-section');
    if (!bannerSection.length) return;
    const imgElement = $('.banner-top-section .image-absolute img');
    const logoWrap = $('.banner-top-section .logo-wrap');
    const bannerHeight = bannerSection.outerHeight();
    const scrollTop = $(window).scrollTop();
    const initialWidth = logoWrap.outerWidth();
    
    const scrollRatio = Math.max(0, Math.min(1, scrollTop / bannerHeight));
    
    const newWidth = initialWidth * (1 - scrollRatio);
    
    imgElement.css('width', `${newWidth}px`);
  }
  
  $(window).on('scroll resize', function () {
    updateImageWidth();
  });
  
  updateImageWidth();
  
});

